import { Activity, useState } from 'react'
import { Filters } from '@haus-storefront-react/filters'
import { FacetFiltersAccordion } from './components/FacetFiltersAccordion'
import { FacetFiltersDropdown } from './components/FacetFiltersDropdown'
import { AriaLiveRegion } from '@components'
import styles from './Filters.module.scss'
import { type EnabledFilter, type FacetValueFilterType } from '@haus-storefront-react/shared-types'
import { type FiltersAttributes } from './_propsFn'
import classNames from 'classnames'
import { DefaultFilterUrlStrategy } from '@haus-storefront-react/strategies'

const DEFAULT_OPEN_ACCORDIONS = 3

export default function FiltersComponent({
  productListIdentifier,
  enabledFilters,
  displayType = 'dropdown',
}: FiltersAttributes<EnabledFilter<FacetValueFilterType>>) {
  const [filterAnnouncement, setFilterAnnouncement] = useState('')

  return (
    <Filters.Root
      enabledFilters={enabledFilters}
      productListIdentifier={productListIdentifier}
      strategies={{ filtersStoreStrategy: new DefaultFilterUrlStrategy() }}
    >
      {(ctx) => {
        const { toggleFacetValue } = ctx
        const facetFilters = enabledFilters?.filter(
          (f) => f.type === 'facet' || f.type === undefined,
        )
        let visibleAccordionIndex = 0

        return (
          <div
            className={classNames(styles.filtersContent, styles[`filtersContent--${displayType}`])}
          >
            <AriaLiveRegion message={filterAnnouncement} />
            <Activity mode={displayType === 'dropdown' ? 'visible' : 'hidden'}>
              {facetFilters?.map((filter) => (
                <FacetFiltersDropdown
                  key={filter.facetCode}
                  facetFilter={filter}
                  toggleFacetValue={toggleFacetValue}
                  onFilterAnnounce={setFilterAnnouncement}
                />
              ))}
            </Activity>
            <Activity mode={displayType === 'accordion' ? 'visible' : 'hidden'}>
              {facetFilters?.map((filter) => (
                <Filters.Group key={filter.facetCode} facetCode={filter.facetCode}>
                  {(facet) => {
                    if (facet.values.length === 0) return null

                    const currentVisibleIndex = visibleAccordionIndex
                    visibleAccordionIndex += 1

                    return (
                      <div>
                        <FacetFiltersAccordion
                          facetFilter={filter}
                          facet={facet}
                          toggleFacetValue={toggleFacetValue}
                          onFilterAnnounce={setFilterAnnouncement}
                          defaultOpen={currentVisibleIndex < DEFAULT_OPEN_ACCORDIONS}
                          index={currentVisibleIndex}
                        />
                      </div>
                    )
                  }}
                </Filters.Group>
              ))}
            </Activity>
          </div>
        )
      }}
    </Filters.Root>
  )
}
